var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"my-5 px-0",attrs:{"width":"100%"}},[_c('v-card-text',[_c('v-text-field',{attrs:{"label":"Поиск","hide-details":"","single-line":"","outlined":"","append-icon":"mdi-magnify","full-width":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }